// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupContainer_XVxru {
	width: 450px;
	background-color: var(--white-color);
	border-radius: 8px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	padding: 16px;
	z-index: 800000;
}

.header_qOAN8 {
	display: flex;
	justify-content: flex-end;
	gap: 7px;
	margin-bottom: 10px;
	align-items: center;
}

.icon_bn_8m {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--text-color-secondary);
	border-radius: 50%;
	cursor: pointer;
	transition: background-color 0.3s ease;
	position: relative;
}
.toolTip_FSaXs {
	position: absolute;
	top: 30px;
	right: -30px;
	font-size: 12px;
	padding: 4px 6px;
	width: max-content;
	border-radius: 4px;
	background: var(--_3c3a3a-color);
	color: var(--white-color);
}
.icon_bn_8m:hover {
	background-color: var(--f5-background);
}

.content_WGyWP {
}

.eventTitle_jdjDg {
	display: flex;
	flex-direction: row;
	margin-right: auto;
	align-items: center;
	font-size: 17px;
	text-wrap: nowrap;
	gap: 13px;
	color: var(--_3c3a3a-color);
	font-weight: bold;
}

.eventColor_x1X1o {
	display: inline-block;
	width: 12px;
	height: 12px;
	background-color: var(--_16c09821-background);
	border-radius: 3px;
	margin-right: 8px;
}

.eventTime_CgAG5 {
	margin-top: -5px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: 14px;
	color: #555;
	margin-bottom: 8px;
	gap: 15px;
}

.reminder_Ztw5N {
	font-size: 14px;
	color: #555;
	display: flex;
	align-items: center;
	gap: 15px;
	margin-bottom: 8px;
}

.organizer_tcFn_ {
	font-size: 14px;
	color: #555;
	display: flex;
	align-items: center;
	gap: 15px;
}

.dot_uUks6 {
	min-width: 10px;
	width: 10px;
	height: 10px;
	border-radius: 3px;
	background: var(--border-color);
	&._100_c3JmM {
		background: var(--_10a37f-background);
	}
	&._101_Fy7m6 {
		background: var(--_16c098-background);
	}
	&._102_MtNkF {
		background: var(--e6fff9-background);
	}
	&._103_H41xo {
		background: var(--_16c09821-background);
	}
	&._200_pA3uM {
		background: #dadada;
	}
	&._201_F8HhF {
		background: #ffa914;
	}
	&._202_aNf_v {
		background: #f7ff14;
	}
	&._203_um_hK {
		background: rgb(255, 30, 30);
	}
	&._204_O9_37 {
		background: rgb(17, 209, 113);
	}
}

.labelsContainer_BNl2F {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 5px;
	border-radius: 4px;
	padding: 3px 10px;
	width: 95px;
	border: 1px solid var(--border-color);
}

.labelsText_Mv1hh {
	font-size: 11px;
	color: var(--text-color-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/EventOptionsPopUp.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,oCAAoC;CACpC,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,QAAQ;CACR,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kCAAkC;CAClC,kBAAkB;CAClB,eAAe;CACf,sCAAsC;CACtC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gCAAgC;CAChC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;AACvC;;AAEA;AACA;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,SAAS;CACT,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,6CAA6C;CAC7C,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;CAC/B;EACC,qCAAqC;CACtC;CACA;EACC,qCAAqC;CACtC;CACA;EACC,oCAAoC;CACrC;CACA;EACC,uCAAuC;CACxC;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,QAAQ;CACR,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC","sourcesContent":[".popupContainer {\n\twidth: 450px;\n\tbackground-color: var(--white-color);\n\tborder-radius: 8px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tpadding: 16px;\n\tz-index: 800000;\n}\n\n.header {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 7px;\n\tmargin-bottom: 10px;\n\talign-items: center;\n}\n\n.icon {\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--text-color-secondary);\n\tborder-radius: 50%;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease;\n\tposition: relative;\n}\n.toolTip {\n\tposition: absolute;\n\ttop: 30px;\n\tright: -30px;\n\tfont-size: 12px;\n\tpadding: 4px 6px;\n\twidth: max-content;\n\tborder-radius: 4px;\n\tbackground: var(--_3c3a3a-color);\n\tcolor: var(--white-color);\n}\n.icon:hover {\n\tbackground-color: var(--f5-background);\n}\n\n.content {\n}\n\n.eventTitle {\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin-right: auto;\n\talign-items: center;\n\tfont-size: 17px;\n\ttext-wrap: nowrap;\n\tgap: 13px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-weight: bold;\n}\n\n.eventColor {\n\tdisplay: inline-block;\n\twidth: 12px;\n\theight: 12px;\n\tbackground-color: var(--_16c09821-background);\n\tborder-radius: 3px;\n\tmargin-right: 8px;\n}\n\n.eventTime {\n\tmargin-top: -5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tfont-size: 14px;\n\tcolor: #555;\n\tmargin-bottom: 8px;\n\tgap: 15px;\n}\n\n.reminder {\n\tfont-size: 14px;\n\tcolor: #555;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 15px;\n\tmargin-bottom: 8px;\n}\n\n.organizer {\n\tfont-size: 14px;\n\tcolor: #555;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 15px;\n}\n\n.dot {\n\tmin-width: 10px;\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 3px;\n\tbackground: var(--border-color);\n\t&._100 {\n\t\tbackground: var(--_10a37f-background);\n\t}\n\t&._101 {\n\t\tbackground: var(--_16c098-background);\n\t}\n\t&._102 {\n\t\tbackground: var(--e6fff9-background);\n\t}\n\t&._103 {\n\t\tbackground: var(--_16c09821-background);\n\t}\n\t&._200 {\n\t\tbackground: #dadada;\n\t}\n\t&._201 {\n\t\tbackground: #ffa914;\n\t}\n\t&._202 {\n\t\tbackground: #f7ff14;\n\t}\n\t&._203 {\n\t\tbackground: rgb(255, 30, 30);\n\t}\n\t&._204 {\n\t\tbackground: rgb(17, 209, 113);\n\t}\n}\n\n.labelsContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 5px;\n\tborder-radius: 4px;\n\tpadding: 3px 10px;\n\twidth: 95px;\n\tborder: 1px solid var(--border-color);\n}\n\n.labelsText {\n\tfont-size: 11px;\n\tcolor: var(--text-color-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupContainer": `popupContainer_XVxru`,
	"header": `header_qOAN8`,
	"icon": `icon_bn_8m`,
	"toolTip": `toolTip_FSaXs`,
	"content": `content_WGyWP`,
	"eventTitle": `eventTitle_jdjDg`,
	"eventColor": `eventColor_x1X1o`,
	"eventTime": `eventTime_CgAG5`,
	"reminder": `reminder_Ztw5N`,
	"organizer": `organizer_tcFn_`,
	"dot": `dot_uUks6`,
	"_100": `_100_c3JmM`,
	"_101": `_101_Fy7m6`,
	"_102": `_102_MtNkF`,
	"_103": `_103_H41xo`,
	"_200": `_200_pA3uM`,
	"_201": `_201_F8HhF`,
	"_202": `_202_aNf_v`,
	"_203": `_203_um_hK`,
	"_204": `_204_O9_37`,
	"labelsContainer": `labelsContainer_BNl2F`,
	"labelsText": `labelsText_Mv1hh`
};
export default ___CSS_LOADER_EXPORT___;
